import { defineStore } from 'pinia'
import { expectObject } from '../composables/expectShape'
import { useAsyncResource, UnauthorizedError } from '../composables/useAsyncResource'

export interface AgentHostStats {
  memory_used_bytes: number | null
  memory_total_bytes: number | null
  disk_used_bytes: number | null
  disk_total_bytes: number | null
  uptime_seconds: number | null
  load_average_1m: number | null
  load_average_5m: number | null
  load_average_15m: number | null
  running_devcontainer_count: number
  cpu_percent: number | null
}

// Admin store for the droplet-wide monitoring snapshot (#860) — read-only,
// no mutations, mirroring useAgentReposStore's fetch/loading/error shape.
export const useAgentHostStatsStore = defineStore('agentHostStats', () => {
  const {
    data: stats,
    loaded,
    loading,
    error: loadError,
    needsAuth,
    refresh: fetchStats,
  } = useAsyncResource<AgentHostStats>(async () => {
    const res = await fetch('/api/v1/agent/host_stats', { credentials: 'include' })
    if (res.status === 401) throw new UnauthorizedError()
    if (!res.ok) throw new Error(`Failed to load host stats: ${res.status}`)
    return expectObject<AgentHostStats>(await res.json(), 'host stats')
  })

  return {
    stats,
    loading,
    loaded,
    needsAuth,
    loadError,
    fetchStats,
  }
})
